import type { ColorValue } from "../color-value";
import { hslaToRgba } from "./hsla-to-rgba";

const colorToRgba = (color: ColorValue) => {
    return hslaToRgba(color.hue, color.saturation, color.light, color.alpha);
};

export { colorToRgba };
